import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';

export type UpsertStep = {
  label: string;
  description: string;
  fraction?: StepFraction;
};

export type StepFraction = {
  numerator: number;
  denominator: number;
};

export type LinearProgressFraction = {
  numerator: number;
  denominator: number;
};

export const LinearProgressWithLabel = (props: LinearProgressProps & LinearProgressFraction) => {
  const numerator = props.numerator;
  const denominator = props.denominator;
  const value = props.denominator === 0 ? 0 : Number(Math.round((numerator / denominator) * 100));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant='determinate' {...props} value={value} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant='body2' color='text.secondary'>
          {`${numerator}/${denominator}`}
        </Typography>
      </Box>
    </Box>
  );
};
